import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';
import RenewalList from '@acorn-portal/shared/src/components/renewal/renewal-list/List';
import PageTitle from '@acorn-portal/shared/src/components/text/PageTitle';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useRenewalOverviews } from '@acorn-portal/shared/src/models/policy-model';
import { clearFullPolicyDetails } from '@acorn-portal/shared/src/store/fullPolicy.slice';
import { clearRenewalState } from '@acorn-portal/shared/src/store/renewal.slice';
import { resetRenewalChanges } from '@acorn-portal/shared/src/store/renewalChanges.slice';
import { Box, Fade, Paper } from '@mui/material';
import { useEffect } from 'react';

const RenewalsListPage = () => {
	const { loadingState, policies } = useRenewalOverviews();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(clearFullPolicyDetails());
		dispatch(clearRenewalState());
		dispatch(resetRenewalChanges());
	}, []);

	return (
		<FullPageLoadingSplash message='Fetching Renewal Details...' loading={loadingState.isLoading}>
			<Paper
				elevation={1}
				sx={{
					borderRadius: '8px',
				}}
			>
				<Fade in>
					<Box
						sx={{
							margin: { xs: 2, md: '2rem' },
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<PageTitle>Your Renewals</PageTitle>
						<RenewalList policies={policies} />
					</Box>
				</Fade>
			</Paper>
		</FullPageLoadingSplash>
	);
};

export default RenewalsListPage;
